<template>
  <div>
    <panel title="客户贷款" border>
      <form-build :form-data="financingDetail" :form-columns="financingColumns"></form-build>
    </panel>
    <panel title="收款记录" border>
      <form-build :form-data="transferRepaymentDetail" :form-columns="transferRepaymentColumns"></form-build>
    </panel>
    <panel :title="'第'+item.plan__sequenceNo+'期（最后还款日：'+ item.rex__expectedRepayDate+'）'" border v-for="(item, idx) in repayPlanList" :key="idx">
      <div v-if="item.needAmount == 0">本期已还清</div>
      <div v-else>本期还清还需：{{item.needAmount}}</div>
      <form-build :form-data="item" :form-columns="repayInfoColumns" v-if="item.rex__extendible == 'N'"></form-build>
      <form-build :form-data="item" :form-columns="repayInfoColumnsTwo" v-if="item.rex__extendible == 'Y'" :form-rules="dataFormRules"></form-build>
    </panel>
    <div class="tr" style="padding-right:15px">本次减免合计：{{freeAmount}}</div>
    <panel title="备注" v-if="editable">
      <el-input type="textarea" v-model="financingDetail.t__remarks" style="margin-bottom:10px;"></el-input>
      <el-button type="primary" @click="handleClickSave">保存</el-button>
      <el-button @click="handleClickClose">关闭</el-button>
    </panel>
  </div>
</template>

<script>
  import Status2CN from "../../filters/Status2CN"
  import moment from 'moment'
  import payChannelOptions from "../../utils/payChannelOptions";
  export default {
    name: "RepayForApproval",
    data() {
      return {
        remarks: '',
        dataFormRules: {
          rex__extendingDays: [
            {
              required: true,
              message: '不能为空！'
            },

          ],
        },
        financingColumns: [
            {
                label: '贷款编号',
                field: 'fi__contractNo'
            },
          {
            label: '客户姓名',
            field: 'fi__customerName'
          },
          {
            label: '利率',
            field: 'fi__interestRate',
            span:24,
            formatter: function (r,c,v) {
              return r.fi__interestRate +'% (' +  Status2CN(r.fi__interestType)+')'
            }
          },
        ],
        transferRepaymentColumns: [
          {
            label: '日期',
            field: 'de__txDate',
            formatter: function (c,v) {
              if(v){
                return moment(v).format('YYYY-MM-DD')
              }else{
                return ''
              }

            }
          },
          {
            label: '金额',
            field: 't__totalAmount',
            formatter: (r,v) => {
              return (Number(v)||0).toFixed(2)
            }
          },
          {
            label: '银行',
            field: 'de__txBankName',
          },
          {
            label: '账号',
            field: 'de__txAccountNo',
          },
          {
            label: '支付方式',
            field: 't__channel',
            span: 24
          },
          {
            label: '备注',
            field: 't__remarks',
            span: 24
          }
        ],
        repayInfoColumns: [
          {
            label: '应还款日',
            field: 'rex__expectedRepayDate',
          },
          {
            label: '上期余额',
            field: 'rex__exBalanceAmount',
            formatter: (r,v) => {
              return (Number(v)||0).toFixed(2)
            }
          },
          {
            label: '应还本金',
            field: 'rex__expectedPrincipalAmount',
            formatter: (r,v) => {
              return (Number(v)||0).toFixed(2)
            }
          },
          {
            label: '实收复利',
            field: 'rex__appliedCompoundInterest',
            formatter: (r,v) => {
              return (Number(v)||0).toFixed(2)
            }
          },
          {
            label: '应还利息',
            field: 'rex__expectedInterestAmount',
            formatter: (r,v) => {
              return (Number(v)||0).toFixed(2)
            }
          },
          {
            label: '实收罚息',
            field: 'rex__appliedOverdueFine',
            formatter: (r,v) => {
              return (Number(v)||0).toFixed(2)
            }
          },
          {
            label: '逾期天数',
            field: 'rex__overdueDays'
          },
          {
            label: '实收利息',
            field: 'rex__appliedInterestAmount',
            component: (r,v) => {
              return {
                template: `<div>{{'${(v||0)}'|formatMoney}} <span v-if="v < r.rex__expectedInterestAmount">( {{ Number((v- r.rex__expectedInterestAmount).toFixed(2))}})</span></div>`,
                data() {
                  return {
                    r,
                    v
                  }
                }
              }
            }
          },
          {
            label: '应收复利',
            field: 'rex__expectedCompoundInterest',
            component: (r,v)=> {
              let disabled = !this.editable
              return {
                template: `<div>{{'${(v||0)}'|formatMoney}}<el-checkbox type="radio" :disabled ="disabled" v-model="r.rex__waiveCompoundInterest" true-label="Y" false-label="N"  v-if="v>0">免除</el-checkbox></div>`,
                data() {
                  return {
                    r,
                    v,
                    disabled
                  }
                }
              }
            }
          },
          {
            label: '实收本金',
            field: 'rex__appliedPrincipalAmount',
            component: (r,v) => {
              return {
                template: `<div>{{'${(v||0)}'|formatMoney}} <span v-if="v < r.rex__expectedPrincipalAmount">( {{ Number((v- r.rex__expectedPrincipalAmount).toFixed(2))}})</span></div>`,
                data() {
                  return {
                    r,
                    v
                  }
                }
              }
            }
          },
          {
            label: '应还罚息',
            field: 'rex__expectedOverdueFine',
            component: (r,v)=> {
              let disabled = !this.editable
              return {
                template: `<div>{{'${(v||0)}'|formatMoney}}<el-checkbox type="radio" :disabled ="disabled"  v-model="r.rex__waiveOverdueFine" true-label="Y" false-label="N"  v-if="v>0">免除</el-checkbox></div>`,
                data() {
                  return {
                    r,
                    v,
                    disabled
                  }
                }
              }
            }
          },
          {
            label: '本期余额',
            field: 'rex__excessAmount',
            formatter: (r,v) => {
              return (Number(v)||0).toFixed(2)
            }
          },
          {
            label: '应收合计',
            field: 'expectedTotalAmount',
            formatter: (r,v) => {
              return (Number(v)||0).toFixed(2)
            },
            span: 24
          },
        ],
        repayInfoColumnsTwo: [
          {
            label: '应还款日',
            field: 'rex__expectedRepayDate',
          },
          {
            label: '上期余额',
            field: 'rex__exBalanceAmount',
            formatter: (r,v) => {
              return (Number(v)||0).toFixed(2)
            }
          },
          {
            label: '应还本金',
            field: 'rex__expectedPrincipalAmount',
            formatter: (r,v) => {
              return (Number(v)||0).toFixed(2)
            }
          },
          {
            label: '实收复利',
            field: 'rex__appliedCompoundInterest',
            formatter: (r,v) => {
              return (Number(v)||0).toFixed(2)
            }
          },
          {
            label: '应还利息',
            field: 'rex__expectedInterestAmount',
            formatter: (r,v) => {
              return (Number(v)||0).toFixed(2)
            }
          },
          {
            label: '实收罚息',
            field: 'rex__appliedOverdueFine',
            formatter: (r,v) => {
              return (Number(v)||0).toFixed(2)
            }
          },
          {
            label: '延期天数',
            field: 'rex__extendingDays',
            component: 'el-input',
            disabled :!this.editable,
            type: 'number',
            props: {
              step: 1
            },
            span:24
          },
          {
            label: '延期利息',
            field: 'rex__extendingInterestAmount',
            formatter: (r,v) => {

             // this.$set(r, 'rex__extendingInterestAmount', extendingInterestAmount.toFixed(2))

             // return  extendingInterestAmount.toFixed(2)
              return (Number(v)||0).toFixed(2)
            }
          },
          {
            label: '实收利息',
            field: 'rex__appliedInterestAmount',
            component: (r,v) => {
              return {
                template: `<div>{{'${(v||0)}'|formatMoney}} <span v-if="v < r.rex__expectedInterestAmount">( {{ Number((v- r.rex__expectedInterestAmount).toFixed(2))}})</span></div>`,
                data() {
                  return {
                    r,
                    v
                  }
                }
              }
            }
          },

          {
            label: '应收复利',
            field: 'rex__expectedCompoundInterest',
            component: (r,v)=> {
              let disabled = !this.editable
              return {
                template: `<div>{{'${(v||0)}'|formatMoney}}<el-checkbox type="radio" :disabled ="disabled" v-model="r.rex__waiveCompoundInterest" true-label="Y" false-label="N"  v-if="v>0">免除</el-checkbox></div>`,
                data() {
                  return {
                    r,
                    v,
                    disabled
                  }
                }
              }
            }
          },
          {
            label: '实收本金',
            field: 'rex__appliedPrincipalAmount',
            component: (r,v) => {
              return {
                template: `<div>{{'${(v||0)}'|formatMoney}} <span v-if="v < r.rex__expectedPrincipalAmount">( {{ Number((v- r.rex__expectedPrincipalAmount))|formatMoney}})</span></div>`,
                data() {
                  return {
                    r,
                    v
                  }
                }
              }
            }
          },
          {
            label: '应还罚息',
            field: 'rex__expectedOverdueFine',
            component: (r,v)=> {
              let disabled = !this.editable
              return {
                template: `<div>{{'${(v||0)}'|formatMoney}}<el-checkbox type="radio" :disabled ="disabled"  v-model="r.rex__waiveOverdueFine" true-label="Y" false-label="N"  v-if="v>0">免除</el-checkbox></div>`,
                data() {
                  return {
                    r,
                    v,
                    disabled
                  }
                }
              }
            }
          },
          {
            label: '本期余额',
            field: 'rex__excessAmount',
            formatter: (r,v) => {
              return (Number(v)||0).toFixed(2)
            }
          },
          {
            label: '应收合计',
            field: 'expectedTotalAmount',
            formatter: (r,v) => {
              return (Number(v)||0).toFixed(2)
            },
            span: 24
          },
        ]
      }
    },
    props: {
      editable: {
        type: Boolean,
        default: true
      },
      repayPlanList: {
        type: Array,
        default:()=>{
          return []
        }
      },
      financingDetail: [Object],
      transferRepaymentDetail: [Object]
    },
    computed: {
      watchChecked() {
        return this.repayPlanList.map(item=>({
          rex__waiveCompoundInterest: item.rex__waiveCompoundInterest,
          rex__waiveOverdueFine: item.rex__waiveOverdueFine,
        }))
      },
      freeAmount() {
        return (this.repayPlanList.reduce( (total, item)=> {
          total += item.rex__waiveCompoundInterest == 'Y' ? item.rex__expectedCompoundInterest : 0
          total += item.rex__waiveOverdueFine == 'Y'? item.rex__expectedOverdueFine : 0

          return total;
        }, 0)).toFixed(2)
      },
      watchLastOverdueDays() {
        return (this.repayPlanList[this.repayPlanList.length -1]||{}).rex__extendingDays||0
      }
    },
    watch: {
      watchChecked: function () {
          if(this.editable){
              this.calculateDetail()
          }

      },
      watchLastOverdueDays: function (newVal, oldVal) {
          if(this.editable){
              this.calculateDetail()
          }
      }
    },
    created() {
        if(this.editable){
            this.calculateDetail()
        }
    },
    methods: {
      handleClickSave() {
        this.$emit('ok')
      },
      handleClickClose() {
        this.$emit('close')
      },
      calculateDetail() {
        let balanceAmount = Number(this.transferRepaymentDetail.t__totalAmount)

        if( this.repayPlanList.length>0)
          balanceAmount = Number(balanceAmount+this.repayPlanList[0].rex__exBalanceAmount)||0

        this.repayPlanList.forEach((item,idx)=> {

          idx > 0 && (item.rex__exBalanceAmount = this.repayPlanList[idx-1].rex__excessAmount)

          item.rex__appliedCompoundInterest = item.rex__waiveCompoundInterest == 'Y' ? 0 : ( balanceAmount > item.rex__expectedCompoundInterest ? item.rex__expectedCompoundInterest :  balanceAmount  )
          balanceAmount = Number((balanceAmount - item.rex__appliedCompoundInterest).toFixed(2))

          item.rex__appliedOverdueFine = item.rex__waiveOverdueFine == 'Y'? 0 : ( balanceAmount > item.rex__expectedOverdueFine ? item.rex__expectedOverdueFine :  balanceAmount )
          balanceAmount = Number((balanceAmount - item.rex__appliedOverdueFine).toFixed(2))


            let interestRate = this.financingDetail.fi__interestRate
            let interestType = this.financingDetail.fi__interestType

            let extendingInterestAmount = 0

            if (item.rex__extendible == 'Y') {
              if (item.rex__extendingDays) {
                if (interestType == 'Yearly') {
                  extendingInterestAmount = (item.rex__extendingDays * interestRate / 36000) * item.rex__expectedPrincipalAmount
                }
                if (interestType == 'Monthly') {
                  extendingInterestAmount = (item.rex__extendingDays * interestRate / 3000) * item.rex__expectedPrincipalAmount
                }
                if (interestType == 'Daily') {
                  extendingInterestAmount = (item.rex__extendingDays * inYterestRate / 100) * item.rex__expectedPrincipalAmount
                }

              }
            }
          item.rex__extendingInterestAmount = extendingInterestAmount.toFixed(2)
         // item.rex__appliedInterestAmount = balanceAmount > item.rex__expectedInterestAmount ? item.rex__expectedInterestAmount : balanceAmount


          if(item.rex__extendible=='M'){

          }else{
            let appliedInterestAmount = ((Number(item.rex__expectedInterestAmount)||0)+ (Number(item.rex__extendingInterestAmount)||0))
            item.rex__appliedInterestAmount = ( balanceAmount > appliedInterestAmount ? appliedInterestAmount : balanceAmount ).toFixed(2)
          }

         /* console.log(balanceAmount)
          console.log(item.rex__expectedPrincipalAmount)
          console.log(item.rex__extendingInterestAmount)*/



          balanceAmount = Number((balanceAmount - item.rex__appliedInterestAmount).toFixed(2))


          item.rex__appliedPrincipalAmount = balanceAmount > item.rex__expectedPrincipalAmount ? item.rex__expectedPrincipalAmount : balanceAmount
          balanceAmount = Number((balanceAmount - item.rex__appliedPrincipalAmount).toFixed(2))

          item.expectedTotalAmount = Number(( (item.rex__waiveCompoundInterest== 'Y' ? 0 : item.rex__expectedCompoundInterest) +  (item.rex__waiveOverdueFine== 'Y' ? 0 : item.rex__expectedOverdueFine) + item.rex__expectedInterestAmount + item.rex__expectedPrincipalAmount).toFixed(2))
          if(item.rex__extendible=='Y'){
            item.expectedTotalAmount = Number(item.expectedTotalAmount) +(Number(item.rex__extendingInterestAmount)||0)
          }
          item.needAmount = Number((item.expectedTotalAmount - item.rex__appliedCompoundInterest -item.rex__appliedOverdueFine-item.rex__appliedInterestAmount-item.rex__appliedPrincipalAmount).toFixed(2))

          item.rex__excessAmount = balanceAmount
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/components/RepayForApproval.vue